module.exports = __webpack_public_path__ + "img/IMG_20200821_085328.ce07eddd.ce07eddd.jpg";